import 'dayjs/locale/fr';
import dayjs from 'dayjs';

import { useTranslation } from 'next-i18next';
import { getSneakerLocale } from 'shared/utils/getSneakerLocale';

export const useI18nextClientSideReady = () => {
  // trigger re-render for copy update upon i18n is initialized (client side translation)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const { ready } = useTranslation(['translation', 'trivia'], {
    bindI18n: 'client side translation initialized',
  });

  if (ready) {
    const locale = getSneakerLocale();
    if (dayjs.locale() !== locale) {
      dayjs.locale(locale);
    }
  }
};
